import { useState } from "react";
import { techniqueCards } from "../content/roadshow";
import { recordRoadshowEvent } from "../lib/analytics";

export function TechniqueCards() {
  const [selectedId, setSelectedId] = useState<string | null>(null);

  async function selectTechnique(cardId: string) {
    setSelectedId(cardId);
    await recordRoadshowEvent({
      sectionId: "pitfalls",
      questionId: "favorite-technique",
      choice: cardId,
      eventType: "choice"
    });
  }

  return (
    <>
      <div className="technique-grid">
        {techniqueCards.map((card) => {
          const isSelected = selectedId === card.id;
          return (
            <article className={isSelected ? "technique-card is-selected" : "technique-card"} key={card.id}>
              <h3>{card.title}</h3>
              <p>{card.lesson}</p>
              <dl>
                <dt>刷题宝里的真实例子</dt>
                <dd>{card.example}</dd>
                <dt>你可以怎么复用</dt>
                <dd>{card.reuse}</dd>
              </dl>
              <button
                type="button"
                className={isSelected ? "is-selected" : ""}
                onClick={() => selectTechnique(card.id)}
              >
                {isSelected ? "已选择" : "我最想带走这个"}
              </button>
            </article>
          );
        })}
      </div>
      {selectedId ? <p className="choice-note technique-note">已记录：这条会进入会后匿名反馈统计。</p> : null}
    </>
  );
}
